module.exports = __webpack_public_path__ + "media/images/icons/country_flags/hu-e404d718cffb5bd06467cbb60786edab.svg";